export default __webpack_public_path__ + "static/media/Dhoopgarh.50ba7f26.jpg";